
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCapacitor04On as ObiCapacitor04OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-capacitor-04-on.js';
 
 
 

 
 export const ObiCapacitor04On = createComponent({
   react: React,
   tagName: 'obi-capacitor-04-on',
   elementClass: ObiCapacitor04OnElement,
   events: {
     
   }
  });
 
 